<template>
  <div class="edit-one-of-profile-wrapper">
    <CommonHeader title="프로필 편집" :is-back-btn="true" :back-fn="close" :is-close-btn="false"/>
    <div class="my-member-wrap">
      <div class="my-member-top" v-if="!isLoading">
        <div class="profile-select">
          <img :src="getImage(currentProfile.image)" :alt="currentProfile.alt" class="profile-sample-img" v-if="currentProfile.image">
        </div>
        <div class="profile-name-modify">
          <label for="profile-name-modify" ><span class="a11y-hidden">프로필1</span></label>
          <input type="text" ref="profileName" title="프로필 이름 변경 입력 영역" :value="modifyName" @input="setProfileName" placeholder="1자 ~ 10자까지 가능합니다. ( 띄어쓰기 포함 )" id="profile-name-modify" />
        </div>
        <div class="profile-img-list">
          <ul>
            <!-- index 가 0 부터 시작안하고 1부터 시작해서.. -->
            <li v-for="(image, index) in profileImage.list" :key="'profileImage' + index"
                class="sample-img-list"
                @click="()=>changeProfileImage(image.imageid)">
              <button :class="currentProfile.image === image.image ? 'ch-profile' : ''">
                <img :src="getImage(image.image)" :alt="image.alt" class="profile-sample-img">
                <span class="checked"></span>
                <span class="profile-change-common"></span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="lnb-modify-btn-box">
        <a href="#" class="btn-cancle" @click.prevent="close">취소</a>
        <a href="#" class="btn-confirm" @click.prevent="submitChangeProfile">확인</a>
      </div>
    </div>

  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { UserService } from '@/common/api/api.service'
import { reverse, get } from 'lodash'
import CommonHeader from '@/components/header/template/commonHeader'
import { appProfileEdit } from '@/common/webview'
import { isApp } from '@/common/util/common'
import { EventBus } from '@/components/eventbus/EventBus'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'LnbEditUserOneOfProfile',
  components: {
    CommonHeader
  },
  data () {
    return {
      currentProfile: {},
      profileImage: {},
      modifyName: null,
      currentImageId: null,
      nameByte: 0,
      profileId: '',
      isLoading: false
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    close () {
      this.$router.back()
    },
    changeProfileImage (imageId) {
      const selectImage = this.currentProfile.image = get(get(this.profileImage, 'list', []).filter((item) => {
        return item.imageid === imageId
      }), '0', {})
      if (this.currentImageId !== get(selectImage, 'imageid', '0')) {
        this.currentProfile.image = get(selectImage, 'image', '')
        this.currentImageId = get(selectImage, 'imageid', '0')
      } else {
        this.currentProfile.image = this.currentProfile.image.image
      }
    },
    profileNameAlert () {
      const text = '1자~10자까지 가능합니다. (띄어쓰기 포함)'
      const callbackFn = () => {
        this.modifyName = this.modifyName.substring(0, 10)
        this.$refs['profileName'].focus()
      }
      EventBus.$emit('open-alert', ({ text, callbackFn }))
    },
    async submitChangeProfile () {
      if (this.modifyName.length > 10) {
        this.profileNameAlert()
        return
      }
      if (this.modifyName.length === 0) {
        utils.alert('이름을 입력해 주세요.')
        return
      }
      if (!isApp()) {
        const cs = JSON.parse(utils.cookies.getItem('cs'))
        if (cs.profile === String(this.profileId)) {
          utils.cookies.changeUserInfo(this.modifyName || this.currentProfile.profilename, this.profileImage.list[this.currentImageId - 1].image)
        }
      }
      const credential = isApp() ? utils.cookies.getCredential() : utils.cookies.userInfo('credential')
      if (credential !== 'none') {
        await UserService.updateUserOneOfProfile({
          profileId: this.profileId,
          imageId: this.currentImageId,
          profileName: this.modifyName || this.currentProfile.profilename,
          credential: credential
        })
        await utils.login.changeProfileProc(utils.cookies.userInfo('profile'))
        if (isApp()) {
          appProfileEdit(String(this.profileId)).then(() => {
            this.close()
          })
        } else {
          this.close()
        }
      }
    },
    setProfileName (e) {
      this.modifyName = e.target.value
      if (this.modifyName.length > 10) this.profileNameAlert()
    },
    setData () {
      this.isLoading = true
      this.profileId = get(this.$route, ['params', 'profileNumber'], 0)
      const imageListReq = UserService.getUserProfileImageList({ offset: 0, limit: 30, orderBy: 'new' })
      const profileId = this.profileId
      const credential = isApp() ? utils.cookies.getCredential() : utils.cookies.userInfo('credential')
      const userProfileReq = UserService.getProfileDetailInfo(profileId, credential)
      const getFileName = path => path.split('/').pop()
      this.axios.all([imageListReq, userProfileReq]).then(this.axios.spread((imageListRes, userProfileRes) => {
        let imageList = get(imageListRes, 'data', {})
        let userProfile = get(userProfileRes, 'data', {})
        const currentUserImage = get(userProfile, 'image', '')
        const currentImageId = get(get(imageList, 'list', []).filter((item) => {
          return getFileName(item.image) === getFileName(currentUserImage)
        }), '0.imageid', '1')
        this.currentImageId = currentImageId
        this.currentProfile = userProfile
        this.profileImage = imageList
        this.profileImage.list = reverse(get(this.profileImage, 'list', []))
        this.modifyName = get(this.currentProfile, 'profilename', '')
        this.isLoading = false
      })).catch(() => {
        this.isLoading = false
      })
    }
  },
  created () {
    this.setData()
  }
}
</script>

<style scoped>
  .edit-one-of-profile-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4300;
    background-color: #1b1b1b;
  }
  .sample-img-list img,
  .profile-select img {
    width: 100%;
  }
  span.checked {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    margin-top: -10px;
    margin-left: -10px;
  }
</style>
